var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_350_517)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.57 35.7001C17.23 35.7001 15.25 33.72 15.25 31.38V25.22C15.2 22.3 16.28 19.55 18.3 17.49C20.32 15.44 23.03 14.3 25.95 14.3C31.91 14.3 36.75 19.15 36.75 25.1V31.26C36.75 33.64 34.81 35.58 32.43 35.58C30.09 35.58 28.11 33.6 28.11 31.26V28.45C28.11 27 29.25 25.86 30.7 25.86C32.15 25.86 33.29 27 33.29 28.45V31.48C33.29 31.89 32.95 32.23 32.54 32.23C32.13 32.23 31.79 31.89 31.79 31.48V28.45C31.79 27.77 31.24 27.36 30.7 27.36C30.02 27.36 29.61 27.91 29.61 28.45V31.26C29.61 32.79 30.9 34.08 32.43 34.08C33.96 34.08 35.25 32.79 35.25 31.26V25.1C35.25 19.97 31.08 15.8 25.95 15.8C23.44 15.8 21.11 16.77 19.37 18.54C17.63 20.31 16.7 22.68 16.75 25.2V31.38C16.75 32.91 18.04 34.2001 19.57 34.2001C21.1 34.2001 22.39 32.91 22.39 31.38V28.57C22.39 27.89 21.84 27.48 21.3 27.48C20.62 27.48 20.21 28.03 20.21 28.57V31.49C20.21 31.9 19.87 32.24 19.46 32.24C19.05 32.24 18.71 31.9 18.71 31.49V28.57C18.71 27.12 19.85 25.98 21.3 25.98C22.75 25.98 23.89 27.12 23.89 28.57V31.38C23.89 33.72 21.91 35.7001 19.57 35.7001Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_350_517",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_350_517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_350_517",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.bac4430f85da722db2f7c73afb2da6cf.svg";
export { ForwardRef as ReactComponent };